var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.templateStyle == 'homepage')?_c('Home',{ref:"HomeRecommendedList",attrs:{"api-url":_vm.apiUrl}}):(_vm.templateStyle == 'detailpage')?_c('Detail',{ref:"DetailRecommendedList",attrs:{"api-url":_vm.apiUrl}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }